import { render } from "./FooterBase.vue?vue&type=template&id=5799d61e"
import script from "./FooterBase.vue?vue&type=script&lang=js"
export * from "./FooterBase.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__